module.exports = __webpack_public_path__ + "img/no-photo.b125dcc3.svg";